import PropTypes from "prop-types";
// form
import { Controller, useFormContext } from "react-hook-form";
// components
import Select from "src/components/template/selector";

// ----------------------------------------------------------------------

export function RHFSelect({
                              name,
                              native,
                              helperText,
                              children,
                              onConditionTypeChange,
                              ...other
                          }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Select
                    {...field}
                    onChange={(e) => {
                        field.onChange(e);

                        if (onConditionTypeChange) {
                            onConditionTypeChange(e.target.value);
                        }
                    }}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                >
                    {children}
                </Select>
            )}
        />
    );
}

RHFSelect.propTypes = {
    children: PropTypes.node,
    helperText: PropTypes.object,
    name: PropTypes.string,
    native: PropTypes.bool,
    onConditionTypeChange: PropTypes.func
};
